// extracted by mini-css-extract-plugin
module.exports = {"diseases":"DiseaseDropdown_diseases__Gi28F"};